<template>
    <div style="margin-bottom: 80px">
        <div class="row">
            <div class="col-6">
                <div>SPV Name</div>
                <input
                type="text"
                class="form-control"
                v-model="addForm.title"
                aria-describedby="title"
                placeholder=""
                />
            </div>
            <div class="col-6">
                <div>Closing Date</div>
                <input
                  min="2000-01-01"
                  type="date"
                 @input="addForm.closingDate = moment($event.target.valueAsDate)"
                  class="form-control"
                  aria-describedby="date"
                  placeholder=""
                />
            </div>
        </div>
        <div class="row">
            <div class="col-6">
              <div>Target Allocation Amount ($)</div>
              <input
                type="number"
                class="form-control"
                v-model="addForm.targetAllocationAmount"
                placeholder=""
                min="0"
              />
            </div>
            <div class="col-6">
                <div>My Commitment ($)</div>
                <input
                  type="number"
                  class="form-control"
                  v-model="addForm.myCommitment"
                  aria-describedby="my commitment"
                  placeholder=""
                />  
            </div>
         </div>
        <div class="row">
            <div class="col-6">
                <div>Minimum Investment Amount ($)</div>
                <input
                    type="number"
                    class="form-control"
                    v-model="addForm.minimumInvestmentAmount"
                    placeholder=""
                    min="0"
                />
            </div>
            <div class="col-6" >
                <label>Security Type</label>
                <v-select
                :options="securityTypeDropdown"
                class="form-control thesis-form-select"
                v-model="addForm.securityType"
              ></v-select>
            </div>
        </div>
        <div class="row d-flex align-items-end">
            <div class="col-6">
                <div>Carry (%)</div>
                <input
                    type="number"
                    class="form-control"
                    v-model="addForm.carry"
                    placeholder=""
                    min="0"
                />
            </div>
            <div class="col-6">
                <button class="btn btn-block btn-primary" style="margin: 0 0 11px 0; background: #5445F3" type="button" @click="handleAddCarryReceipt">Add Carry Receipt</button>
            </div>
        </div>
        <div class="row" >
            <div class="col-6" >
                <div style="margin-bottom: 10px" >Management Fee Type</div>
                <el-radio-group v-model="addForm.managementFee.type">
                    <el-radio 
                        v-for="item in managementFeeOptions"
                        :key="item.value" 
                        :value="item.value" 
                        :label="item.label">
                            {{item.label}}
                    </el-radio>
                </el-radio-group>
                <input
                    type="number"
                    class="form-control"
                    v-model="addForm.managementFee.value"
                    placeholder=""
                    min="0"
                />
            </div>
        </div>
        <div class="row d-flex justify-content-end">
            <div class="col-6 d-flex justify-content-end" >
            <button class="todo-form-submit-button btn btn-primary" :disabled="showSpinner" @click="handleSave">
                Save
                <b-spinner
                    v-if="showSpinner"
                    style="float: right"
                    small
                    label="Loading..."
                ></b-spinner>
            </button>
            </div>
        </div>
            <add-carry-receipt
                v-model="addCarryReceiptProps"
                v-if="showAddCarryReceiptModal"
                :carryRecipients="addForm.carryRecipients"
                @addCarryRecipients="addCarryRecipients"
            ></add-carry-receipt>
    </div>
    
</template>

<script>
import { Select, Option, Radio, RadioGroup } from "element-ui";
import api from "../../../axios_api";
import moment from "moment";
import AddCarryReceipt from "../Dialogs/AddCarryReceipt";

export default {
    name: "spv-create-workspace",
    components: {
        [AddCarryReceipt.name]:AddCarryReceipt,
        [Select.name]: Select,
        [Option.name]: Option,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup
    },
    data(){
        return{
            addCarryReceiptProps:{},
            showAddCarryReceiptModal:false,
            addForm: {
                workspace_type: "SPV",
                title: "",
                closingDate: "",
                targetAllocationAmount: '',
                myCommitment: "",
                minimumInvestmentAmount: "",
                carry: "",
                securityType: "",
                carryRecipients: [],
                managementFee : {
                    type: "",
                    value: ""
                }
            },
            moment: moment,
            securityTypeDropdown: ["SAFE", "Convertible Note", "Equity", "Crypto"],
            managementFeeOptions: [{
                label: "Flat Fee",
                value: "Flat Fee"
            },
            {
                label: "% Fee",
                value: "% Fee"
            }
            ],
            showSpinner: false,
            disableButton: true,
        }
    },
    methods: {
        handleAddCarryReceipt(){
            this.addCarryReceiptProps = {
            isShow: true,
            data: {},
            };
            this.showAddCarryReceiptModal=true
        },
        handleSave(){
            let self = this
            this.showSpinner= true;
           let payload = {
               type: "SPV",
               ...this.addForm,
               managementFee: {
                   ...this.addForm.managementFee
               }
           }
           this.$store.dispatch("workspace/apiPostworkspacesInst", payload).then((user) => {
               let payload = {
                account: user.success.account,
                workspace_id: user.success.workspace,
                workspace_title: self.addForm.title,
                workspace_type: "SPV",
                sectors: self.sectorValues,
                stages: self.stageValues,
              };
              self.$store.dispatch("workspace/apiFetchworkspaces");
              self.$emit("switchWorkspace", payload);
           }).catch(err=> {
               console.log(err)
           }).finally(() => {
           })
        },
        addCarryRecipients(data){
            this.addForm.carryRecipients = data;
        }
    }
}
</script>

<style scoped>

</style>